module.exports = __webpack_public_path__ + "static/media/1.57fd96db.png";